<template>
  <header v-show="showLayout">
    <nav class="header_nav">
      <div class="header_logo d-flex justify-content-center">
        <router-link to="/login" class="logo" v-show="!isLogin">
          <img src="@/assets/img/MSC_logo.png" alt="マナビス化粧品会員サイト" />
        </router-link>
        <router-link to="/" class="logo" v-show="isLogin">
          <img src="@/assets/img/MSC_logo.png" alt="マナビス化粧品会員サイト" />
        </router-link>
        <!-- <button v-show="isLogin" id="LogOut" type="button" class="btn only_pc" v-on:click="logout">
          ログアウト
        </button> -->
      </div>
    </nav>
  </header>
</template>

<script>
import Authenticate from "@/modules/Authenticate";
let auth = new Authenticate();

export default {
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
    showLayout() {
      return this.$store.state.showLayout;
    }
  },
  methods: {
    logout() {
      auth.logout();
    }
  },
};
</script>

<!-- このコンポーネント固有のCSSを記載 -->
<style scoped>
 .header_nav .logo img {
   height: 50px;
 }
 @media (min-width: 992px) {
   .header_nav .logo img {
     height: 70px;
   }
 }
</style>
